import { Fragment, useState } from 'react';
import { PageNavbar } from '@/pages/account';
import { AccountUserProfileContent } from '.';
import { UserProfileHero } from '@/partials/heros';
import { KeenIcon } from '@/components';
import { Container } from '@/components/container';
import { MenuArrow } from '@/components/menu';
import { useLanguage } from '@/i18n';
import { useAuthContext } from '@/auth';
import { getApiErrorMessage, isSuperAdmin } from '@/utils';
import profileService from '@/services/setting/profileService';
import { toast } from 'sonner';

const AccountUserProfilePage = () => {
  const { isRTL } = useLanguage();
  const {auth, updateUser} = useAuthContext()
  // Bumped after a photo upload so My Information re-reads the profile and its
  // own avatar preview does not go stale.
  const [profileVersion, setProfileVersion] = useState(0);

  // Sends the image on its own — the profile endpoint takes a partial update.
  const handlePhotoSelect = async (file) => {
    const formData = new FormData();
    formData.append('profile_image', file);
    formData.append('_method', 'PUT');

    try {
      const { data, status } = isSuperAdmin()
        ? await profileService.superAdminUpdateProfile(formData)
        : await profileService.updateProfile(formData);

      if (status) {
        updateUser({ profile_image: data.user.profile_image }, true);
        setProfileVersion((version) => version + 1);
        toast.success('Profile photo updated.');
      }
    } catch (error) {
      console.error('Error updating profile photo', error);
      toast.error('Could not update your photo', {
        description: getApiErrorMessage(error, 'Please try again in a moment.'),
      });
    }
  };

  const buildMenuToggle = () => (
    <MenuArrow>
      <KeenIcon icon="down" className="text-2xs [.menu-dropdown_&]:-rotate-90" />
    </MenuArrow>
  );
  return <Fragment>
      <PageNavbar />
      <UserProfileHero onPhotoSelect={handlePhotoSelect} />

      {/* <Container> */}
        {/* <Navbar> */}
        {/* <div className="grid">
          <div className="scrollable-x-auto">
            <Menu highlight={true} className="gap-3">
              <MenuItem
                toggle="dropdown"
                trigger="hover"
                dropdownProps={{
                  placement: isRTL() ? 'bottom-end' : 'bottom-start',
                  modifiers: [{ name: 'offset', options: { offset: [0, 0] } }]
                }}
                className="border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <MenuLink className="gap-1.5 pb-2 lg:pb-4 px-2">
                  <MenuTitle className="text-nowrap text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-medium menu-item-here:text-primary menu-item-here:font-medium menu-item-show:text-primary menu-link-hover:text-primary">
                    General
                  </MenuTitle>
                  <MenuArrow>
                    <KeenIcon icon="down" className="text-2xs text-gray-500 menu-item-active:text-primary menu-item-here:text-primary menu-item-show:text-primary menu-link-hover:text-primary" />
                  </MenuArrow>
                </MenuLink>
                <MenuSub className="menu-default" rootClassName="py-2 min-w-[200px]">
                  <MenuItem>
                    <MenuLink path="/account/home/user-profile">
                      <MenuTitle>Profile</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink path="/account/security/overview">
                      <MenuTitle>Security</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink path="/account/security/overview">
                      <MenuTitle>Company Setting</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink path="/account/home/tags">
                      <MenuTitle>Tags</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink path="/account/home/custom-fields">
                      <MenuTitle>Custom Fields</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                </MenuSub>
              </MenuItem>
              
              <MenuItem
                toggle="dropdown"
                trigger="hover"
                dropdownProps={{
                  placement: isRTL() ? 'bottom-end' : 'bottom-start',
                  modifiers: [{ name: 'offset', options: { offset: [0, 0] } }]
                }}
                className="border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <MenuLink path="/invoices" className="gap-1.5 pb-2 lg:pb-4 px-2">
                  <MenuTitle className="text-nowrap text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-medium menu-item-here:text-primary menu-item-here:font-medium menu-item-show:text-primary menu-link-hover:text-primary">
                    Invoices
                  </MenuTitle>
                </MenuLink>
              </MenuItem >


              <MenuItem
                toggle="dropdown"
                trigger="hover"
                dropdownProps={{
                  placement: isRTL() ? 'bottom-end' : 'bottom-start',
                  modifiers: [{ name: 'offset', options: { offset: [0, 0] } }]
                }}
                className="border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <MenuLink className="gap-1.5 pb-2 lg:pb-4 px-2">
                  <MenuTitle className="text-nowrap text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-medium menu-item-here:text-primary menu-item-here:font-medium menu-item-show:text-primary menu-link-hover:text-primary">
                    User Settings
                  </MenuTitle>
                  <MenuArrow>
                    <KeenIcon icon="down" className="text-2xs text-gray-500 menu-item-active:text-primary menu-item-here:text-primary menu-item-show:text-primary menu-link-hover:text-primary" />
                  </MenuArrow>
                </MenuLink>
                <MenuSub className="menu-default" rootClassName="py-2 min-w-[200px]">
                  <MenuItem>
                    <MenuLink path="/account/members/users">
                      <MenuTitle>Users</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink path="/account/members/roles">
                      <MenuTitle>Roles</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                </MenuSub>
              </MenuItem >

              <MenuItem
                toggle="dropdown"
                trigger="hover"
                dropdownProps={{
                  placement: isRTL() ? 'bottom-end' : 'bottom-start',
                  modifiers: [{ name: 'offset', options: { offset: [0, 0] } }]
                }}
                className="border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
              >
                <MenuLink className="gap-1.5 pb-2 lg:pb-4 px-2">
                  <MenuTitle className="text-nowrap text-sm text-gray-700 menu-item-active:text-primary menu-item-active:font-medium menu-item-here:text-primary menu-item-here:font-medium menu-item-show:text-primary menu-link-hover:text-primary">
                    Integration
                  </MenuTitle>
                  <MenuArrow>
                    <KeenIcon icon="down" className="text-2xs text-gray-500 menu-item-active:text-primary menu-item-here:text-primary menu-item-show:text-primary menu-link-hover:text-primary" />
                  </MenuArrow>
                </MenuLink>
                <MenuSub className="menu-default" rootClassName="py-2 min-w-[200px]">
                  <MenuItem
                    toggle="dropdown"
                    trigger="hover"
                    dropdownProps={{
                      placement: isRTL() ? 'left-start' : 'right-start',
                      modifiers: [{ name: 'offset', options: { offset: isRTL() ? [10, 0] : [-10, 0] } }]
                    }}
                  >
                    <MenuLink>
                      <MenuTitle>Design</MenuTitle>
                      {buildMenuToggle()}
                    </MenuLink>
                    <MenuSub className="menu-default" rootClassName="py min-w-[200px]">
                      <MenuItem>
                        <MenuLink path="/services/design/web">
                          <MenuTitle>Web Design</MenuTitle>
                        </MenuLink>
                      </MenuItem>
                      <MenuItem>
                        <MenuLink path="/services/design/graphic">
                          <MenuTitle>Graphic Design</MenuTitle>
                        </MenuLink>
                      </MenuItem>
                    </MenuSub>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink path="/services/marketing">
                      <MenuTitle>Marketing</MenuTitle>
                    </MenuLink>
                  </MenuItem>
                </MenuSub>
              </MenuItem>
            </Menu>
          </div>
        </div> */}
          {/* <PageMenu /> */}

          {/* <NavbarActions>
            <a href="#" className="btn btn-sm btn-primary">
              <KeenIcon icon="mouse-square" /> Hire Us
            </a>
            <button type="button" className="btn btn-sm btn-light">
              <KeenIcon icon="users" /> Follow
            </button>
            <button className="btn btn-sm btn-icon btn-light">
              <KeenIcon icon="messages" />
            </button>
            <NavbarDropdown />
          </NavbarActions> */}
        {/* </Navbar> */}
      {/* </Container> */}
      
      <Container>
        <AccountUserProfileContent refreshKey={profileVersion} />
      </Container>
    </Fragment>;
};
export { AccountUserProfilePage };